// extracted by mini-css-extract-plugin
module.exports = {"container":"_1gOhULGVZuNg3catCDAX6o"};